import { API_URL } from "@shared/services/api.config";

const ACCOUNT_ME_ENDPOINT = `${API_URL}/api/account/me`;

async function fetchAccountMe(): Promise<Response> {
  return fetch(ACCOUNT_ME_ENDPOINT, {
    method: "GET",
    credentials: "include",
    headers: {
      Accept: "application/json",
    },
  });
}

export async function isSessionExpired(): Promise<boolean> {
  try {
    const response = await fetchAccountMe();
    return response.status === 401;
  } catch {
    return false;
  }
}
